import React from "react";
import { SUPPORT_URL } from "../../../constants";

const DecisionError = () => {

  return (
    <div className="errorText">
      <span>
        Something went wrong processing your application. Please
      </span>
      <a
        className="text-green-primary"
        href={SUPPORT_URL}
        target="_blank"
        rel="noreferrer"
      >
        &nbsp;contact us
      </a>
      <span> and a representative will be in touch with you shortly.</span>
    </div>
  );
};

export default DecisionError;
